import { render } from "./LetterSpacing.vue?vue&type=template&id=16b227e1&scoped=true&ts=true"
import script from "./LetterSpacing.vue?vue&type=script&lang=ts"
export * from "./LetterSpacing.vue?vue&type=script&lang=ts"

import "./LetterSpacing.vue?vue&type=style&index=0&id=16b227e1&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b227e1"]])

export default __exports__